import React from 'react'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { CustomHeaderText } from 'src/components'
import { offsetOptionalFieldsSelector } from 'src/features'

const OffsetPreparedNameRow: React.FC = () => {
  const { t } = useTranslation()
  const { use_company_name_in_offset } = useAppSelector(offsetOptionalFieldsSelector)

  const label = {
    NAME: t('footPrint.Name'),
    COMPANY: t('settings.CompanyName')
  }[use_company_name_in_offset ? 'COMPANY': 'NAME']

  return <CustomHeaderText text={label} />
}

export default OffsetPreparedNameRow
